export default class EmailTemplatesModel {
  constructor(
    public TemplateName: string = '',
    public IsDefault: boolean = false,
    public IsSelected: boolean = false,
    public TemplateType: string = '',
    public FontFamily: string = '',
    public LogoUrl: string = '',
    public LogoPosition: string = '',
    public HeaderAccentColor: string = '',
    public HeroImageUrl: string = '',
    public EmailAccentColor: string = '',
    public EmailTextColor: string = '',
    public FooterAccentColor: string = '',
    public FooterTextColor: string = '',
    public FooterContent: string | null = null,
    public Id: number = 0,
    public UserId: string | null = null,
    public AppId: number = 0,
    public EventId: number = 0,
    public EventPageId: number = 0,
    public EmailType: number = 0,
    public EmailTypeProp: string = '',
    public EmailSubject: string = '',
    public EmailBody: string = '',
    public HasRegistrationLink: boolean = false,
    public LabelText: string = '',
    public BackgroundColor: string = '',
    public LabelColor: string = '',
    public CreatedOn: string = '',
    public ModifiedOn: string = '',
    public IsDeleted: boolean = false,
    public TestEmailReceiver: string | null = null,
    public AllowEditResponses: boolean = false,
    public HasEditResponsesRegistrationLink: boolean = false,
    public EditResponsesLabelText: string | null = null,
    public EditResponsesBackgroundColor: string | null = null,
    public EditResponsesLabelColor: string | null = null,
    public ListOfTickets: any = null,
    public HasEventAccessLink: boolean = false,
    public EventAccessLabelText: string | null = null,
    public EventAccessBackgroundColor: string | null = null,
    public EventAccessLabelColor: string | null = null,
    public HasEventWebPageAccessLink: boolean = false,
    public EventWebPageAccessLabelText: string | null = null,
    public EventWebPageAccessBackgroundColor: string | null = null,
    public EventWebPageAccessLabelColor: string | null = null,
    public TicketBuyersEmail: any = null,
  ){}

  public static createEmpty(): EmailTemplatesModel{
    return new EmailTemplatesModel();
  }
}
